import React from 'react';

const StepIndicator = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Basic Info' },
    { number: 2, label: 'Fees' },
    { number: 3, label: 'Stake Tokens' },
    { number: 4, label: 'Finalize' }
  ];

  const getStepClass = (stepNumber) => {
    if (currentStep === stepNumber) return 'active-step';
    if (currentStep > stepNumber) return 'completed-step';
    return '';
  };

  const getStepLineClass = (stepNumber) => {
    if (currentStep > stepNumber) return 'completed';
    if (currentStep === stepNumber) return 'active';
    return '';
  };

  const getParaClass = (stepNumber) => {
    if (currentStep >= stepNumber) return 'whitepara';
    return 'inactivepara';
  };

  return (
    <div className="stepmain">
      {steps.map((step, index) => (
        <div key={step.number} className={`stepinner ${getStepClass(step.number)}`}>
          <span className={`stepline ${getStepLineClass(step.number)}`}>
            {currentStep > step.number ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 3 L4.5 8.5 L2 6" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            ) : (
              step.number
            )}
          </span>
          <p className={`steppara ${getParaClass(step.number)}`}>
            {step.label}
            {index < steps.length - 1 && (
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M4.5 9 L7.5 6 L4.5 3" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            )}
          </p>
        </div>
      ))}
    </div>
  );
};

export default StepIndicator;